import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RouterOutlet } from '@angular/router';
import { TopBarComponent } from './shared/components/top-bar/top-bar.component';
import { UpdateService } from './core/services/update.service';

@Component({
  selector: 'idh-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TopBarComponent, RouterOutlet],
})
export class AppComponent {
  private readonly translate = inject(TranslateService);
  private readonly updates = inject(UpdateService);

  constructor() {
    this.translate.setDefaultLang('pl');
    this.updates.init();

    effect(() => {
      if (!this.updates.updateAvailable()) return;
      this.updates.promptAndApplyUpdate();
    });
  }
}
